import { translate } from '../../common/helpers/translate.helper';
import { TextShimmer } from '../../common/TextShimmer/TextShimmer';
import type { TextShimmerProps } from '../../common/TextShimmer/TextShimmer';

interface DemandRecalculatingProps {
    variant: TextShimmerProps['variant'];
}

export const DemandRecalculating = ({ variant }: DemandRecalculatingProps) => (
    <TextShimmer variant={variant} fontWeight={600}>
        {translate('demandDefinition.recalculating')}
    </TextShimmer>
);
